export default "__VITE_ASSET__OlQqQtz4__"